<pm-calendar
  [ctrl]="ctrl"
  [showClear]="true"
  [placeholder]="formField.placeholder"
  [readonlyInput]="true"
  [selectionMode]="formField?.selectionMode || 'single'"
  [inline]="!!formField?.inline"
  [maxDate]="formField?.maxDate"
  [minDate]="formField?.minDate"
  (monthChanged)="onMonthChanged($event)"
  [disabledDates]="formField.disabledDates || []"
/>
